var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 11.9792C21.8786 13.3541 21.5574 14.7103 20.9375 15.9375C20.2025 17.4081 19.0727 18.645 17.6744 19.5097C16.2762 20.3744 14.6648 20.8327 13.0208 20.8334C11.646 20.8369 10.2897 20.5157 9.0625 19.8959L3.125 21.875L5.10417 15.9375C4.4843 14.7103 4.16308 13.3541 4.16667 11.9792C4.1673 10.3352 4.62564 8.72383 5.49033 7.3256C6.35503 5.92737 7.59193 4.7975 9.0625 4.06253C10.2897 3.44267 11.646 3.12145 13.0208 3.12503H13.5417C15.7129 3.24481 17.7636 4.16124 19.3012 5.69884C20.8388 7.23644 21.7552 9.28717 21.875 11.4584V11.9792Z",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3257,
    cy: 12.4996,
    r: 1.63043,
    fill: "#8F9DC9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7613,
    cy: 12.4996,
    r: 1.63043,
    fill: "#8F9DC9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.6ce0f9a9c596e46f4229288835a11deb.svg";
export { ForwardRef as ReactComponent };